
import { useState } from 'react';
import { useReports } from './hooks/useReports';
import { exportToExcel } from './lib/excelExport';

export default function ComplianceReports() {
  const { compliance } = useReports();
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  
  const q = compliance({ month, year });
  
  if (q.isLoading) return <div className="p-6">Loading...</div>;
  
  const c = q.data || {};
  
  const handleExportExcel = () => {
    const summaryData = c.summary?.map((s: any) => [s.type, s.count, s.value]) || [];
    exportToExcel('Compliance_Report', [{
      name: 'Summary',
      headers: ['Type', 'Count', 'Value'],
      data: summaryData
    }]);
  };
  
  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-semibold text-[var(--color-primary)]">Compliance Reports</h1>
      
      <div className="flex gap-2">
        <input 
          type="number" 
          placeholder="Month" 
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)]" 
          onChange={e => setMonth(e.target.value)} 
        />
        <input 
          type="number" 
          placeholder="Year" 
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)]" 
          onChange={e => setYear(e.target.value)} 
        />
        <button 
          onClick={handleExportExcel} 
          className="px-4 py-2 bg-[var(--color-primary)] text-white rounded-md hover:bg-[var(--color-primary)]/90 transition-colors whitespace-nowrap cursor-pointer"
        >
          Export Excel
        </button>
      </div>
      
      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h2 className="font-semibold mb-2 text-[var(--color-accent)]">GST Compliance</h2>
          <p className="mb-1">Invoices Reported: <span className="font-medium">{c.gst?.reported || 0}</span></p>
          <p>Pending Uploads: <span className="font-medium text-orange-600">{c.gst?.pending || 0}</span></p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h2 className="font-semibold mb-2 text-[var(--color-accent)]">Vendor Compliance</h2>
          <p className="mb-1">KYC Verified: <span className="font-medium text-green-600">{c.vendor?.verified || 0}</span></p>
          <p>KYC Pending: <span className="font-medium text-red-600">{c.vendor?.pending || 0}</span></p>
        </div>
      </div>
      
      {/* Additional compliance metrics */}
      <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
        <div className="px-6 py-4 border-b">
          <h3 className="text-lg font-semibold">Compliance Summary</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-[var(--color-accent)]/10">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Count</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Value</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {c.summary?.map((s: any, index: number) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{s.type}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{s.count}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{s.value}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      s.status === 'compliant' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {s.status || 'pending'}
                    </span>
                  </td>
                </tr>
              )) || (
                <tr>
                  <td colSpan={4} className="px-6 py-12 text-center text-gray-500">
                    No compliance data available for the selected period
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
